<!-- <div class="back-overlay">
</div> -->
<div class="offer-bottom-popup">
  <ion-card *ngIf="paymentSuccess">
    <ion-card-header>
      <ion-card-title class="ion-text-center success-color"
        >Congratulations !</ion-card-title
      >
      <ion-icon
        name="close-outline"
        class="padding-horizontal-5 close-i success-color"
        (click)="close(false)"
      >
      </ion-icon>
      <!-- <ion-card-subtitle>
        <span class="ion-text-center">
          <span style="color: #01A3A4;">Congratulations !</span>
          <ion-icon name="close-outline" (click)="close(false)" style="right: 0;position: absolute;font-size: 2rem;color: #01A3A4;">
          </ion-icon>
        </span>
      </ion-card-subtitle> -->
    </ion-card-header>

    <ion-card-content>
      <ion-row>
        <ion-col class="ion-text-center">
          <img src="./assets/img/payment-success.svg" style="height: 20vh" />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center ion-padding-top">
          <span class="title-txt"
            >Your {{ (planData && planData?.smartPlan) ? "Smart Plan" : plan === "ultra" ? "Ultra Premium" : plan === "premium" ? "Premium" : "" }} plan has
            been activated</span
          >
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center ion-padding-top">
          <span class="title-sub-txt"
            >All the
            {{ (planData && planData?.smartPlan) ? "Smart Plan" : plan === "ultra" ? "Ultra Premium" : "Premium" }} features can be
            accessed from</span
          >
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center ion-padding-top">
          <img src="./assets/img/payment-success-footer.svg" />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-button expand="block" class="subscribe" (click)="close(true)"
            >LET'S BEGIN</ion-button
          >
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>

  <ion-card *ngIf="!paymentSuccess">
    <ion-card-header>
      <ion-card-title class="ion-text-center pay_fail" style="margin-top: 20px"
        >Payment Failed !</ion-card-title
      >
      <ion-icon
        class="padding-horizontal-5 close-i failed-color"
        (click)="close(false)"
        name="close-circle"
      ></ion-icon>
      <!-- <ion-icon
        name="close-outline"
        class="padding-horizontal-5 close-i failed-color"
        (click)="close(false)"
      >
      </ion-icon> -->
      <!-- <ion-card-subtitle>
        <span class="ion-text-center">
          <span style="color: #01A3A4;">Congratulations !</span>
          <ion-icon name="close-outline" (click)="close(false)" style="right: 0;position: absolute;font-size: 2rem;color: #01A3A4;">
          </ion-icon>
        </span>
      </ion-card-subtitle> -->
    </ion-card-header>

    <!-- <ion-card-content> -->
    <ion-row>
      <ion-col class="ion-text-center">
        <img
          src="../../../assets/newImages/pay_fail.svg"
          style="height: 20vh"
        />
        <!-- <img src="./assets/img/payment-failed.png" style="height: 20vh" /> -->
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center ion-padding-top center">
        <p class="err_text">There was an error during transaction</p>
        <!-- <span class="title-txt">There was an error during transaction.</span> -->
      </ion-col>
    </ion-row>
    <ion-row style="background: #fafafa; padding: 10px">
      <ion-col class="ion-text-center center flex_col">
        <p class="pay_err">Your payment was not confirmed.</p>
        <p class="pay_err1">If your payment was deducted please contact us:</p>
        <a
          class="left a"
          [href]="
            iosDevice
              ? 'https://api.whatsapp.com/send?phone=+919999118595'
              : 'whatsapp://send?phone=+919999118595'
          "
        >
          <img src="./assets/img/whatsapp.png" class="height-4vh" />
          <a class="phone"> 9999118595</a>
        </a>
        <a class="left a" href="mailto:admin@smartdietplanner.com">
          <img src="../../../assets/newImages/mail.png" class="height-4vh" />
          <a class="phone"> admin@smartdietplanner.com</a>
        </a>

        <!-- <span class="title-sub-txt"
          >Your payment was not confirmed. If your payment was deducted please
          contact us:</span
        > -->
      </ion-col>
    </ion-row>
    <!-- <ion-row>
      <ion-col class="ion-text-center ion-padding-top vertical-center">
        <img src="./assets/img/whatsapp.png" class="height-4vh" />
        <a
          class="link-text"
          href="whatsapp://send?phone=+919999118595"
          *ngIf="!iosDevice"
          >9999118595</a
        >
        <a
          class="link-text"
          href="https://api.whatsapp.com/send?phone=+919999118595"
          *ngIf="iosDevice"
          >9999118595</a
        >
      </ion-col>
    </ion-row>
    <ion-row>
      <ion-col class="ion-text-center ion-padding-top vertical-center">
        <img src="./assets/img/gmail.svg" class="height-4vh" />
        <a class="link-text" href="mailto:admin@smartdietplanner.com"
          >admin@smartdietplanner.com</a
        >
      </ion-col>
    </ion-row> -->
    <ion-row>
      <ion-col>
        <ion-button expand="block" class="subscribe" (click)="close(true)"
          >Retry Again</ion-button
        >
      </ion-col>
    </ion-row>
    <!-- </ion-card-content> -->
  </ion-card>

  <ion-card *ngIf="order">
    <ion-card-header>
      <ion-card-title class="ion-text-center success-color"
        >Thank You for your order</ion-card-title
      >
      <ion-icon
        name="close-outline"
        class="padding-horizontal-5 close-i success-color"
        (click)="close(false)"
      >
      </ion-icon>
    </ion-card-header>

    <ion-card-content>
      <ion-row>
        <ion-col class="ion-text-center">
          <img src="./assets/img/payment-success.svg" style="height: 20vh" />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center ion-padding-top">
          <span class="title-txt"
            >Your {{ plan === "ultra" ? "Ultra Premium" : "Premium" }} plan has
            been activated</span
          >
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center ion-padding-top">
          <span class="title-sub-txt"
            >All the
            {{ plan === "ultra" ? "Ultra Premium" : "Premium" }} features can be
            accessed from</span
          >
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col class="ion-text-center ion-padding-top">
          <img src="./assets/img/payment-success-footer.svg" />
        </ion-col>
      </ion-row>
      <ion-row>
        <ion-col>
          <ion-button expand="block" class="subscribe" (click)="close(true)"
            >LET'S BEGIN</ion-button
          >
        </ion-col>
      </ion-row>
    </ion-card-content>
  </ion-card>
</div>
